function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect } from 'react';
import { useField, useFormikContext } from 'formik';
import GenericFormElement from '../GenericFormElement';
import useAriaDescribedByField from '../../../hooks/useAriaDescribedByField';
const TextAreaField = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    name,
    label,
    onBlur,
    onChange,
    className,
    defaultValue,
    verticalSpacing,
    visualValidation,
    description,
    optionalLabel,
    maxCharacters,
    isLiveValidationDisabled
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    submitCount
  } = useFormikContext();
  const {
    ariaDescribedBy
  } = useAriaDescribedByField({
    field,
    meta,
    description
  });
  useEffect(() => {
    helpers.setTouched(false);
  }, []);
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    name: name,
    label: label,
    meta: meta,
    helpers: helpers,
    className: className,
    defaultValue: defaultValue,
    visualValidation: visualValidation,
    verticalSpacing: verticalSpacing,
    description: description,
    optionalLabel: optionalLabel,
    maxCharacters: maxCharacters,
    submitCount: submitCount,
    isLiveValidationDisabled: isLiveValidationDisabled
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    ref: ref,
    id: name,
    className: "form-text"
  }, props, field, {
    "aria-describedby": ariaDescribedBy,
    onBlur: e => {
      if (onBlur) onBlur(e);
      field.onBlur(e);
    },
    onChange: e => {
      if (onChange) onChange(e);
      field.onChange(e);
    }
  })));
});
export default TextAreaField;